import { ConnectedUser } from "$src/domain/realtime/ConnectedUser";
import { writable } from "svelte/store";

export const connectedUsers = writable<ConnectedUser[]>([]);

export function addConnectedUser(user: ConnectedUser) {
    connectedUsers.update(users => [...users, user]);
}

export function updateConnectedUser(user: ConnectedUser) {
    connectedUsers.update(users => {
      const index = users.findIndex(u => u.connectionId === user.connectionId);
      if (index === -1) {
        return [...users, user];
      } else {
        const updatedUsers = [...users];
        updatedUsers[index] = user;
        return updatedUsers;
      }
    });
  }

export function setConnectedUsers(users: ConnectedUser[]) {
    connectedUsers.set(users);
}

export function removeConnectedUser(connectionId: string) {
    connectedUsers.update(users => users.filter(user => user.connectionId !== connectionId));
}

export function clearConnectedUser() {
  connectedUsers.set([]);
}